var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.bmi
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "bmi",
              class: _vm.statusClass(_vm.bmi(_vm.person, _vm.weight))
            },
            [
              _c(
                "div",
                {
                  staticClass: "number",
                  class: _vm.statusClass(_vm.bmi(_vm.person, _vm.weight))
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.bmi(_vm.person, _vm.weight)) +
                      "\n\t\t\t"
                  )
                ]
              ),
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.status(_vm.bmi(_vm.person, _vm.weight))) +
                  "\n\t\t\t"
              ),
              _c("div", { staticClass: "info" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.t("health", "Weight", {})) +
                    " " +
                    _vm._s(_vm.weight + _vm.person.weightUnit) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.t("health", "Date", {})) +
                    " " +
                    _vm._s(_vm._f("formatMyDate")(_vm.date)) +
                    "\n\t\t\t"
                )
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }